import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
	ViewRef,
	HostListener,
    Inject
} 
from '@angular/core';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStringAdapter } from 'dps-lib';
// Material
import { MatDialog, MatDialogRef, MatTabChangeEvent, MAT_DIALOG_DATA} from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
import { PhieuKiemTra, PhieuKiemTraKetQua } from '../../../qa-qc/kiem-tra-hang-hoa/phieu-kiem-tra/phieu-kiem-tra-model/phieu-kiem-tra.model';
import { MauPhieuKiemTra } from '../../../qa-qc/kiem-tra-hang-hoa/mau-phieu-kiem-tra/mau-phieu-kiem-tra-model/mau-phieu-kiem-tra.model';
import { HangNhapKho } from '../../../qa-qc/kiem-tra-hang-hoa/danh-sach-hang-ton-kho/danh-sach-hang-ton-kho-model/danh-sach-hang-ton-kho.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { PhieuKiemTraService } from '../../../qa-qc/kiem-tra-hang-hoa/phieu-kiem-tra/phieu-kiem-tra-service/phieu-kiem-tra.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { TokenStorage } from 'app/core/auth/_services/token-storage.service';
import { LayoutUtilsService } from 'app/core/_base/crud/utils/layout-utils.service';
import { SubheaderService } from 'app/core/_base/layout/services/subheader.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { FileImport } from '../../../dung-chung/__model/file-import.model';

@Component({
	selector: 'm-phieu-kiem-tra-pass-khan',
	templateUrl: './phieu-kiem-tra-pass-khan.component.html',
	styleUrls: ['../yeu-cau-xuat-khan.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter }]
})

export class PhieuKiemTraPassKhanComponent implements OnInit{

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport : ElementRef;
	@ViewChild('fileUpload', { static: true }) fileUpload;
	@ViewChildren('focusDetail') focusDetail;
    
	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/
    
    /*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
        {
            stt: 1,
            name: 'TenNhomChiTieu',
            displayName: 'Chỉ tiêu kiểm tra',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'TenChiTieu',
            displayName: 'Chỉ tiêu kiểm tra',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 3,
            name: 'TieuChuan',
            displayName: 'Tiêu chuẩn',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'Ketqua',
            displayName: 'Kết quả',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'Danhgiaketqua',
            displayName: 'Đạt',
            alwaysChecked: false,
			isShow: true
		}
	];
	/* ------------------------------------------------------------------*/
    
    /*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */

    /*------------------------ Danh sách Khách hàng ----------------------*/
	listKH : any[] = [];
	selectKH : string = '';
	filteredKH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KHFilterCtrl: string = '';
    /* ------------------------------------------------------------------ */

    /* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	/* ------------------------------------------------------------------ */

    /* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	masterForm: FormGroup;
	considerForm:FormGroup;
	confirmForm: FormGroup;				
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
    items: PhieuKiemTra;
    mauPhieu: MauPhieuKiemTra;
    listKQ: PhieuKiemTraKetQua[] = [];
    bindingItem: HangNhapKho;
	listChiTiet: PhieuKiemTraKetQua[] = [];
    tmpListChiTiet: PhieuKiemTraKetQua[] = [];
    flagFileImport: FileImport[] = [];
	flagFileDownload: any;
	/* ------------------------------------------------------------------ */


    /*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []	
	viewLoading: boolean = false;   	// Loading khi mở dialog
	processImport: boolean = false;		// Có đang chạy import
    flagTab: number = 0;				// Định danh tab đang chạy
	openTimKiemNangCao = false;
	waittingAddDetail = false;
	isUpdate = false;
	optionsLoaiPhieu: any[] = [];
	loaiPhieuTao: number;
	GhiChu: string = '';
	QuyetDinhLoHang: string = '';
	ChoPhepXuatKho: string = '1';
	listFileName: string = '';
	isDisableButton: boolean = false;
    /* ------------------------------------------------------------------ */

    constructor(
		private services: PhieuKiemTraService,
        private dungChungService: DungChungService,
		private formBuild: FormBuilder,
		public  dialog: MatDialog,
		private router: Router,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
        private activatedRoute: ActivatedRoute,
        public dialogRef: MatDialogRef<PhieuKiemTraPassKhanComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
    ) {}
    
    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
		
        /*Load list danh sách tương ứng trước khi tạo form */
        this.ListState();
		/*Load cấu hình config form */
        this.CONFIG = new CommonConFig();
		this.items = new PhieuKiemTra();
        this.items.clear();
        this.optionsLoaiPhieu = PhieuKiemTra.optionLoaiPhieu;

        this.isUpdate = false;
		this.bindingItem = this.data.data;
		console.log(this.bindingItem);
        this.loaiPhieuTao = this.checkLoaiForm();
        this.getInfoMauKiemTra(this.bindingItem.IdHh)
        if(this.loaiPhieuTao == this.optionsLoaiPhieu[2].id)
            this.ListKH(this.bindingItem.IdHh);

		this.createForm();

		this.services.getDetail(this.data.Id).subscribe(res => {
            if(res.status == 1){
                this.items = res.data;
                this.copyValueToBindingData();
                if(this.masterForm != null){
                    this.bindingValueHangNhapKho();
                    this.masterForm.controls["SoPhieu"].setValue(this.items.Sophieu);
                    this.changeDetectView();
                }
            }
        });
        
        

		this.title = this.getTitle();

		let breadcrumbs = [{ title: 'QA&QC' }, { title: 'Phiếu kiểm tra', page: '/phieu-kiem-tra'}, { title: 'Chi tiết phiếu kiểm tra' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
    }
    ngOnDestroy() {
		this.clearDataImport();
    }
    /* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
    createForm(){
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
        this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.items.Nguoitao = +idUser;

        if(this.bindingItem != null && this.loaiPhieuTao == this.optionsLoaiPhieu[0].id){
            this.masterForm = this.formBuild.group({
                SoPhieu: [''],
                NgayLapPhieu: [new Date()],
                TenNguoiLap: [tenNguoiLap],
                TrangThai: [this.nameState,Validators.required],
                MaHH: [''],
                TenHH: [''],
                NCC: [''],
                Solo: [''],
                NgaySanXuat: [''],
                HanSD: [''],
                SoLuong:[this.CONFIG.DEFAULT_NUMBER_VALUE, 
                            Validators.compose([Validators.min(0.01),
                            Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)])
                ],  
                DVT: [''],
                NgayNhan: [''],
                SoPhieuNK: [''],
                NgaySXLoTruoc: [new Date(), Validators.required],
                TimeBatDau: ['08:00', Validators.required],
                TimeKetThuc: ['09:00', Validators.required],
                NgayKiemTra: [new Date(), Validators.required],
                NgayPhatHanh: [new Date(), Validators.required],
            });

            /*Disable các trường dữ liệu không thay đổi */
            this.masterForm.disable();
            /*------------------------------------------------------------------*/
        }
        else if(this.bindingItem != null && this.loaiPhieuTao == this.optionsLoaiPhieu[1].id){
            this.masterForm = this.formBuild.group({
                SoPhieu: [''],
                NgayLapPhieu: [new Date()],
                TenNguoiLap: [tenNguoiLap],
                TrangThai: [this.nameState,Validators.required],
                MaHH: [''],
                TenHH: [''],
                NCC: [''],
                Solo: [''],
                NgaySanXuat: [''],
                SoLuong:[this.CONFIG.DEFAULT_NUMBER_VALUE, 
                            Validators.compose([Validators.min(0.01),
                            Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)])
                ],  
                DVT: [''],
                NgayNhan: [new Date()],
                SoPhieuNK: [''],
                NgayKiemTra: [new Date(), Validators.required],
                NgayPhatHanh: [new Date(), Validators.required],
                TimeBatDau: ['08:00', Validators.required],
                TimeKetThuc: ['09:00', Validators.required],
            });

            /*Disable các trường dữ liệu không thay đổi */
            this.masterForm.disable();
            /*------------------------------------------------------------------*/
        }
        else if(this.bindingItem != null && this.loaiPhieuTao == this.optionsLoaiPhieu[2].id){
            this.masterForm = this.formBuild.group({
                SoPhieu: [''],
                NgayLapPhieu: [new Date()],
                TenNguoiLap: [tenNguoiLap],
                TrangThai: [this.nameState,Validators.required],
                MaHH: [''],
                TenHH: [''],
                KhachHang: [this.selectKH, Validators.required],
                Solo: [''],
                NgaySanXuat: [''],
                ThoiHanSuDung: [],
                SoLuong:[this.CONFIG.DEFAULT_NUMBER_VALUE, 
                            Validators.compose([Validators.min(0.01),
                            Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIRED)])
                ],  
                DVT: [''],
                NgayKiemTra: [new Date(), Validators.required],
                NgayPhatHanh: [new Date(), Validators.required],
            });

            /*Disable các trường dữ liệu không thay đổi */
            this.masterForm.disable();
            /*------------------------------------------------------------------*/
        }

		if(this.listState.length > 0){
			this.checkState();
		}

		this.considerForm = this.formBuild.group({
			LyDo: [''],
		})

		this.confirmForm = this.formBuild.group({
			LyDo: [''],
		})
		
		this.considerForm.disable();
		this.confirmForm.disable();
        this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail(){
		if(this.items.Id > 0){
			this.masterForm.controls["SoPhieu"].setValue(this.items.Sophieu);
			// this.masterForm.controls["NgayLapPhieu"].setValue(this.items.NgayYeuCau);
			// this.masterForm.controls["TenNguoiLap"].setValue(this.items.TenNguoiTao);
			// this.masterForm.controls["LoaiPhieu"].setValue(this.items.LoaiPhieu);
			// this.masterForm.controls["DienGiai"].setValue(this.items.DienGiaiLyDo);
			this.checkState();

			/*Add dữ liệu chi tiết*/
			// if(this.items.listChiTiet.length > 0){
			// 	this.listChiTiet = this.items.listChiTiet;
			// 	this.tmpListChiTiet = [];
			// 	for(let i = 0; i < this.listChiTiet.length; i++){
			// 		if(this.listChiTiet[i].SoLuongDaMua == null){
			// 			this.listChiTiet[i].SoLuongDaMua = 0;
			// 		}
			// 		if(this.listChiTiet[i].SoLuongDaNhan == null){
			// 			this.listChiTiet[i].SoLuongDaNhan = 0;
			// 		}
			// 		let tmpElement = new DeNghiMuaHangCT();
			// 		tmpElement.copy(this.listChiTiet[i])
			// 		this.tmpListChiTiet.push(tmpElement);

			// 		let filterTmp = new ReplaySubject<any[]>(1)
			// 		filterTmp.next(this.listPBSD.slice());
			// 		this.arrayPBSDForEachHH.push(filterTmp);
			// 	}
			// 	this.tmpListChiTiet = [...this.tmpListChiTiet];
			// 	this.updateTT();
			// }
		}
    }
    bindingValueHangNhapKho(){
        if(this.bindingItem != null){
            if(this.bindingItem != null && this.loaiPhieuTao == this.optionsLoaiPhieu[0].id){
                this.masterForm.controls["MaHH"].setValue(this.bindingItem.MaHH);
                this.masterForm.controls["TenHH"].setValue(this.bindingItem.TenHH);
                this.masterForm.controls["NCC"].setValue(this.bindingItem.TenNCC)
                this.masterForm.controls["Solo"].setValue(this.bindingItem.Solo);
                this.masterForm.controls["NgaySanXuat"].setValue(this.bindingItem.Ngaysanxuat);
                this.masterForm.controls["HanSD"].setValue(this.bindingItem.Hansudung);
                this.masterForm.controls["SoLuong"].setValue(this.f_number(this.bindingItem.Soluong));
                this.masterForm.controls["DVT"].setValue(this.bindingItem.TenDVT);
                this.masterForm.controls["NgayNhan"].setValue(this.bindingItem.NgayNhapKho);
                this.masterForm.controls["SoPhieuNK"].setValue(this.bindingItem.SophieuNK);
            }
            else if(this.bindingItem != null && this.loaiPhieuTao == this.optionsLoaiPhieu[1].id){
                this.masterForm.controls["MaHH"].setValue(this.bindingItem.MaHH);
                this.masterForm.controls["TenHH"].setValue(this.bindingItem.TenHH);
                this.masterForm.controls["NCC"].setValue(this.bindingItem.TenNCC)
                this.masterForm.controls["Solo"].setValue(this.bindingItem.Solo);
                this.masterForm.controls["NgaySanXuat"].setValue(this.bindingItem.Ngaysanxuat);
                this.masterForm.controls["SoLuong"].setValue(this.f_number(this.bindingItem.Soluong));
                this.masterForm.controls["DVT"].setValue(this.bindingItem.TenDVT);
                this.masterForm.controls["NgayNhan"].setValue(this.bindingItem.NgayNhapKho);
                this.masterForm.controls["SoPhieuNK"].setValue(this.bindingItem.SophieuNK);
            }
            else if(this.bindingItem != null && this.loaiPhieuTao == this.optionsLoaiPhieu[2].id){
                this.masterForm.controls["MaHH"].setValue(this.bindingItem.MaHH);
                this.masterForm.controls["TenHH"].setValue(this.bindingItem.TenHH);
                this.masterForm.controls["Solo"].setValue(this.bindingItem.Solo);
				this.masterForm.controls["NgaySanXuat"].setValue(this.bindingItem.Ngaysanxuat);
				this.masterForm.controls["ThoiHanSuDung"].setValue(this.monthDiff(
					this.bindingItem.Ngaysanxuat == null ? '' :	new Date(this.bindingItem.Ngaysanxuat), 
					this.bindingItem.Hansudung == null ? '' : new Date(this.bindingItem.Hansudung)
				));
                this.masterForm.controls["SoLuong"].setValue(this.f_number(this.bindingItem.Soluong));
				this.masterForm.controls["DVT"].setValue(this.bindingItem.TenDVT);		
            }
		}
		if(this.listState.length > 0){
			this.checkState();
		}
	}
	copyValueToBindingData(){
		if(this.items != null && this.bindingItem != null){
			this.bindingItem.IdCtnk = this.items.IdNKCT;
			this.bindingItem.SophieuNK = this.items.SoPhieuNK;
			this.bindingItem.IdHh = this.items.HanghoaId;
			this.bindingItem.MaHH = this.items.MaHang;
			this.bindingItem.TenHH = this.items.TenHang;
			this.bindingItem.IdLoaiHH = this.items.IdLoai;
			this.bindingItem.TenLoaiHH = this.items.TenLoai;
			this.bindingItem.IdNCC = this.items.NccId;
			this.bindingItem.TenNCC = this.items.TenNCC;
			this.bindingItem.IdLo = this.items.IdLot;
			this.bindingItem.Solo = this.items.Solosx;
			this.bindingItem.Ngaysanxuat = this.items.Ngaysx;
			this.bindingItem.Hansudung = this.items.Hansudung;
			this.bindingItem.Soluong = this.items.Soluong;
			this.bindingItem.NgayNhapKho = this.items.Ngaynhan;
			this.bindingItem.QuyetDinhLoHang = this.items.Quyetdinhtext;
			this.bindingItem.IdDVT = this.items.IdDVT;
			this.bindingItem.TenDVT = this.items.TenDVT;

			this.selectKH = '' + this.items.KhachhangId;
			if(this.masterForm.controls != null && this.loaiPhieuTao == this.optionsLoaiPhieu[0].id){
				this.masterForm.controls["NgaySXLoTruoc"].setValue(this.items.Ngaysxlotruoc);
				this.masterForm.controls["TimeBatDau"].setValue(this.items.Thoigianbatdautiepnhan);
				this.masterForm.controls["TimeKetThuc"].setValue(this.items.Thoigianketthuctiepnhan);
				this.masterForm.controls["NgayKiemTra"].setValue(this.items.Ngaykiemtra);
				this.masterForm.controls["NgayPhatHanh"].setValue(this.items.Ngayphathanh);
			}
			else if(this.masterForm.controls != null && this.loaiPhieuTao == this.optionsLoaiPhieu[1].id){
				this.masterForm.controls["TimeBatDau"].setValue(this.items.Thoigianbatdautiepnhan);
				this.masterForm.controls["TimeKetThuc"].setValue(this.items.Thoigianketthuctiepnhan);
				this.masterForm.controls["NgayKiemTra"].setValue(this.items.Ngaykiemtra);
				this.masterForm.controls["NgayPhatHanh"].setValue(this.items.Ngayphathanh);
			}
			else if(this.masterForm.controls != null && this.loaiPhieuTao == this.optionsLoaiPhieu[2].id){
				this.masterForm.controls["KhachHang"].setValue(this.selectKH);
				this.masterForm.controls["NgayKiemTra"].setValue(this.items.Ngaykiemtra);
				this.masterForm.controls["NgayPhatHanh"].setValue(this.items.Ngayphathanh);
			}

			this.GhiChu = this.items.Ghichu;
			this.QuyetDinhLoHang = this.items.Quyetdinhtext;
			this.ChoPhepXuatKho = this.items.Chophepxuatkho == true ? '1' : '0';

			if(this.items.listFileDinhKem != null && this.items.listFileDinhKem.length > 0){
				this.listFileName = '';
				this.items.listFileDinhKem.forEach(x => {
					this.listFileName += ', ' + x.filename;
				})
				this.listFileName = this.listFileName.substr(2);
			}

			if(this.items.listPhieuKiemTraKetQua != null && this.items.listPhieuKiemTraKetQua.length > 0){
				this.listKQ.forEach(x => {
					var item = this.items.listPhieuKiemTraKetQua.find(y => y.MauphieukiemtraChitieuId == x.MauphieukiemtraChitieuId)
					if( item != null){
						x.Ketqua = item.Ketqua;
						x.Danhgiaketqua = item.Danhgiaketqua;
					}
				})
			}

			
			if(this.items.listPhieuKiemTraLsThaoTac != null && this.items.listPhieuKiemTraLsThaoTac.length > 0){
				this.considerForm.controls["LyDo"].setValue(this.getConsiderHistory(this.items.Id,1));
				this.confirmForm.controls["LyDo"].setValue(this.getConfirmHistory(this.items.Id,1));
			}
		}
	}
    getTitle(): string {
		return 'Chi tiết phiếu kiểm tra ' + this.checkLoaiHHTitle();
    }
    getInfoMauKiemTra(idHH: number){
		
        this.services.getInfoMauKiemTra(idHH).subscribe(res => {
            if(res.status == 1){
                this.mauPhieu = res.data
                if(this.mauPhieu != null){
                    this.mauPhieu.listMauPhieuKiemTraNhomChiTieu.forEach(x => {
                        var listChiTieu = x.listMauPhieuKiemTraChiTieu
                        listChiTieu.forEach(y => {
                            var itemKQ = new PhieuKiemTraKetQua();
                            itemKQ.clear();
                            itemKQ.MauphieukiemtraId = this.mauPhieu.Id;
                            itemKQ.MauphieukiemtraChitieuId = y.Id;
                            itemKQ.MauphieukiemtraIdNhom = x.Id;
                            itemKQ.TenNhomChiTieu = x.Tennhom;
                            itemKQ.TenChiTieu = y.Tenchitieu;
                            itemKQ.TieuChuan = y.Tieuchuan;
                            itemKQ.SoTieuChiTrongNhom = listChiTieu.length;
                            
                            this.listKQ.push(itemKQ);
                        })
                    })
                    this.listKQ = [...this.listKQ];
                }
                this.changeDetectView();
            }
        });
    }
    checkLoaiHHTitle(){
        if(this.bindingItem != null && this.bindingItem != undefined){
            let idLoaiHH = this.bindingItem.IdLoaiHH;
            
            var itemLoai = PhieuKiemTra.optionsLoaiHang.find(x => x.id == idLoaiHH);
            if(itemLoai != null){
                return itemLoai.name.toLowerCase();;
            }
        }
        return '';
    }
    checkLoaiForm(){
        if(this.bindingItem != null && this.bindingItem != undefined){
            let idLoaiHH = this.bindingItem.IdLoaiHH;
            var itemLoai = PhieuKiemTra.optionLoaiPhieu.find(x => x.value.findIndex(element => element == idLoaiHH) > -1);
            if(itemLoai != null){
                return itemLoai.id
            }
        }
        return PhieuKiemTra.DEFAULT_LOAIPHIEU;
	}
	getConsiderHistory(Id: any, type: number){
		let item = this.items.listPhieuKiemTraLsThaoTac.find(x => x.PhieudenghiId == Id 
												&& x.Loaithaotac == PhieuKiemTra.optionsTinhTrang[3].value)
	
		if(item == null){
			item = this.items.listPhieuKiemTraLsThaoTac.find(x => x.PhieudenghiId == Id 
				&& x.Loaithaotac == PhieuKiemTra.optionsTinhTrang[2].value)
		}
		if(item != null && type == 0){
			return item.Noidung == "True" ? "1" : "2"
		}
		else if(item != null && type == 1){
			return item.Ghichu;
		}
		else if(item != null && type == 2){
			return item.TenNguoiThaoTac;
		}
		else if(item != null && type == 3){
			return item.Ngaythaotac;
		}
		return '';
	}
	getConfirmHistory(Id: any, type: number){
		let item = this.items.listPhieuKiemTraLsThaoTac.find(x => x.PhieudenghiId == Id 
												&& x.Loaithaotac == PhieuKiemTra.optionsTinhTrang[5].value)
	
		if(item == null){
			item = this.items.listPhieuKiemTraLsThaoTac.find(x => x.PhieudenghiId == Id 
				&& x.Loaithaotac == PhieuKiemTra.optionsTinhTrang[4].value)
		}
		if(item != null && type == 0){
			return item.Noidung == "True" ? "1" : "2"
		}
		else if(item != null && type == 1){
			return item.Ghichu;
		}
		else if(item != null && type == 2){
			return item.TenNguoiThaoTac;
		}
		else if(item != null && type == 3){
			return item.Ngaythaotac;
		}
		return '';
	}
    /* -----------------------------------------------------------------------*/


    /*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
    /* -----------------------------------------------------------------------*/


    /*------------------------- Hàm lấy danh sách-----------------------------*/
    ListState(){
		this.dungChungService.listState(PhieuKiemTra.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.items.Trangthai){
				this.nameState = element.Description;
				if(this.masterForm != null)
					this.masterForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
    }
    
    ListKH(idHH: number){
		this.dungChungService.layKhachHangBaseHH(idHH).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKH = res.data;
				this.filteredKH.next(this.listKH.slice());
				if(this.items.Id == null || this.items.Id <= 0){
					this.selectKH = this.listKH[0].IdKH + '';
					if(this.masterForm.controls != null && this.loaiPhieuTao == this.optionsLoaiPhieu[2].id){
						this.masterForm.controls["KhachHang"].setValue(this.selectKH);
					}
				}
				this.changeDetectView();
			};
		});
	}
	filterKH() {
		if (!this.listKH) {
			return;
		}
		let search = this.KHFilterCtrl;
		if (!search) {
			this.filteredKH.next(this.listKH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKH.next(
			this.listKH.filter(ts =>
				ts.TenKH.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
    /* -----------------------------------------------------------------------*/

    
    /*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
    showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength') 
			|| (controls[columnName].value.length > 22 
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
				
			}else{
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			}else{
				event.target.value = this.f_number((min));
			}
		}
	}
    /* -----------------------------------------------------------------------*/


    /*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
    getFormatDate(v: string = '') {
        if (v != null && v!= undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	compareDate(firstVal: any, secondVal: any) {
		if(firstVal != null && firstVal != undefined && secondVal != null && secondVal != undefined){
			let d1 = new Date(firstVal);
			let d2 = new Date(secondVal);
			if (d1.getTime() > d2.getTime())
				return true;
		}
		return false;
	}
	monthDiff(d1, d2) {
		var diff = d1.getMonth() - d2.getMonth() + 
					(12 * (d1.getFullYear() - d2.getFullYear()));

		return diff <= 0 ? (diff*(-1)) : diff
	}
    /* -----------------------------------------------------------------------*/


    /*---------------------------- Thao tác trên form ------------------------*/
	checkRowspan(index: number){
		let item = this.listKQ[index];
		if(index == 0)
			return item.SoTieuChiTrongNhom;
		if(index >= 1 && item.MauphieukiemtraIdNhom != this.listKQ[index-1].MauphieukiemtraIdNhom){
			return item.SoTieuChiTrongNhom;
		}
		return null;
	}
	isChangeTTPhieu(){
		let isChange = false;
		// if(this.items.Id > 0){
		// 	if(this.masterForm.controls["LoaiPhieu"].value != this.items.LoaiPhieu){
		// 		isChange = true
		// 		return isChange;
		// 	}
		// 	if( this.masterForm.controls["DienGiai"].value != this.items.DienGiaiLyDo){
		// 		isChange = true
		// 		return isChange;
		// 	}

		// 	let isAllnew = false;
		// 	this.tmpListChiTiet.forEach(x => {
		// 		if(x.Id == 0){
		// 			isAllnew = true;
		// 		}
		// 	})
		// 	if(isAllnew && this.items.Id > 0)
		// 		return true;

		// 	if(this.items.listChiTiet.length != this.tmpListChiTiet.length){
		// 		isChange = true
		// 		return isChange;
		// 	}

		// }
		// else{
		// 	var phongban = '';
		// 	this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

		// 	if(this.masterForm.controls["LoaiPhieu"].value != DeNghiMuaHang.optionsLoaiPhieu[0].value
		// 	|| ( this.masterForm.controls["DienGiai"].value != null && this.masterForm.controls["DienGiai"].value != '')
		// 	|| this.tmpListChiTiet.length > 0){
		// 		isChange = true;
		// 	}
		// }
		return isChange;
	}
	back(){
		this.dialogRef.close({});
	}
    /* -----------------------------------------------------------------------*/


    /*--------------------------- Hàm xử lý File------------------------------*/
	selectFile() {
		let el: HTMLElement = this.fileUpload.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			let fileNameList = [];
			for(let i = 0; i < evt.target.files.length; i++){
				let file = evt.target.files[i];
				this.flagFileDownload = file;
				let fileName = file.name;
				fileNameList.push(fileName);
			}
			this.listFileName = fileNameList[0];
			for(var i = 1; i < fileNameList.length; i++){
				this.listFileName += ', ' + fileNameList[i];
			}

			var files = evt.target.files;
			for(var i = 0; i < files.length; i++){
				this.dataImport(files[i]);
			}
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
		this.changeDetect.detectChanges();
	}
	dataImport(file: any){
		var listFileBase64Tmp = this.flagFileImport
		var extension = file.name.split('.').pop();
		var fileName = file.name.substring(0,file.name.indexOf(extension) - 1);

		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			let base64Str = reader.result as string;
			var metaIdx = base64Str.indexOf(';base64,');

			base64Str = base64Str.substr(metaIdx + 8);

			var fileImport = new FileImport();
			fileImport.clear();
			fileImport.filename = fileName;
			fileImport.extension = extension;
			fileImport.base64 = base64Str;
		
			listFileBase64Tmp.push(fileImport);
		};
	}
	clearDataImport(){
		this.services.data_import.next([]);
	}
	downloadFile(idFile: number) {
		let linkdownload = this.services.downloadTemplate(idFile);
		window.open(linkdownload);
		// if(idctdn > 0){
		// 	let linkdownload = this.services.downloadTemplate(idctdn);
		// 	window.open(linkdownload);
		// }
		// else{
		// 	let objectURL;
		// 	const file = item.fileTmpDownLoad;
		// 	objectURL = URL.createObjectURL(file);
		// 	var downloadLink = document.createElement("a");
		// 	downloadLink.href = objectURL;
		// 	downloadLink.download = file.name;
		// 	document.body.appendChild(downloadLink);
		// 	downloadLink.click();
		// 	document.body.removeChild(downloadLink);
		// }
	
	}
	/* -----------------------------------------------------------------------*/

	/*------------------------------ Extend Options --------------------------*/
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth' });
		}, 200);
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
        if (event.key == "Escape") {
			this.router.navigateByUrl('phieu-kiem-tra', { relativeTo: this.activatedRoute });
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/
}